/* @flow */
import React from 'react';
// $FlowIgnore
import GDCLogoImg from './images/NCI_GDCDataSubPortal.png';

export default function GDCLogo({style}: Object): React.Element {
  return (
    <img style={style} src={GDCLogoImg} alt="National Cancer Institute – GDC Data Submission Portal"/>
  );
}
